
define('modules/application/system-selection-single',[
    'app',
    'backbone',
    'modules/application/header',
    'modules/application/subheader',
    'modules/application/wizard/classes/kits/audioVideoKits',
    'modules/application/wizard/classes/kits/automationKits',
    'modules/application/wizard/classes/kits/intrusionDetectionKits',
    'modules/application/wizard/classes/kit',
    './popup'
  ],

  function(app, Backbone, Header, Subheader, AudiovideoKits, AutomationKits, IntrusionDetectionKits, Kit, Popup) {

    // Create a new module
    var SystemSelectionSingle = app.module();

    SystemSelectionSingle.Model = Backbone.Model.extend({

      defaults : {
        kits : []
      },

      initialize: function() {
        var retrievedCategorySystems = [],
          retrievedAccessoryLines = [],
          retrievedKit = [];

        this.kits = [];

        // window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen", this.accessoryLineChosenEventHandler);
        // window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.accessoryLineChosenEventHandler, this);
        this.retrieveAccessoryLine();
        
        this.retrieveCategorySystem();
        
        
        
        //this.retrieveKit();
        /*window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen", window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
        if(!window.BticinoS4B.Instances.Models.ApplicationModel.get("systemAppName") && (BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType()=="webapp")){
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", undefined);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", undefined);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", undefined);
        }*/
      },

      retrieveKit: function() {
        var self = this;
      },

      accessoryLineChosen: function(idColors, idAccessoryLine){
        if(!idColors)
          idColors=null;

        var line  = _.filter(window.BticinoS4B.Instances.Models.ApplicationModel.get('accessoryLines'), function(iterableLine){return iterableLine.id===idAccessoryLine;})[0];
        var color = _.filter(line.colors, function(iterableColor){return iterableColor.id===idColors;})[0];

        if(color.id){
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", color);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", line);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", color.accessoryLineId);
        }else{
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", null);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", line);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", line.id);
        }

        window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen", window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
        
        $('#serieProgettoLabel').html(window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine").name);

        if (idColors)
        {
          $('#coloreLabel').html(window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor").name);
        }
        else
        {
          $('#coloreLabel').html('-');
        }
      },

      retrieveAccessoryLine: function() {
        var self = this,
          successCallback = function(data) {
            //console.log(data);
            for (var i = 0; i < data.lines.length; i++) {
              for (var j = 0; j < data.lines[i].colors.length; j++) {
                //console.log(data.lines[i].colors[j]);

                if (data.lines[i].colors[j].accessoryLineId == '0') {
                  data.lines[i].colors[j].image = '';
                } else if (data.lines[i].colors[j].accessoryLineId == '4') {
                  data.lines[i].colors[j].image = '/assets/img/4.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '5') {
                  data.lines[i].colors[j].image = '/assets/img/5.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '8') {
                  data.lines[i].colors[j].image = '/assets/img/8.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '13') {
                  data.lines[i].colors[j].image = '/assets/img/13.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '14') {
                  data.lines[i].colors[j].image = '/assets/img/14.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '21') {
                  data.lines[i].colors[j].image = '/assets/img/21.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '31') {
                  data.lines[i].colors[j].image = '/assets/img/31.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '32') {
                  data.lines[i].colors[j].image = '/assets/img/32.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '33') {
                  data.lines[i].colors[j].image = '/assets/img/33.jpg';
                }
              }
            }
            retrievedAccessoryLines = data.lines;

            window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLines", retrievedAccessoryLines);

            return retrievedAccessoryLines;
          },
          failCallback = function(e) {
            console.log(e);
          };

        if (!window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines")){
          window.BticinoS4B.Instances.Services.wizardServices.getAccessoryLines(successCallback, failCallback, self);
        }else{
          return window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines");
        }
      },

      retrieveKitsForTheCurrentSystems: function(currentSystem) {
        var self            = this,
            kits            = self.get('kits'),
            i               = 0,
            triggerEmpty    = function(idSystem){
              self.trigger('kit:retrieved', [[], idSystem]);
            },
            successCallback = function(data) {

              var valorizePackage = function(productsData){
                productsData = productsData.products;
                var x = 0, y= 0, systemIdTmp=[];

                var mainProduct       = _.filter(productsData, function(iterableItem){return iterableItem.mnemonic===1;})[0];
                var secondaryProducts = _.filter(productsData, function(iterableItem){return iterableItem.mnemonic!==1;});

                data.packages[i] = _.extend(data.packages[i], mainProduct);
                data.packages[i].secondaryProducts = secondaryProducts;

                for (x = 0; x < data.packages.length; x++) {
                  if(!kits[data.packages[x].systemId]){
                    if(data.packages[x].productCode){
                      kits[data.packages[x].systemId] = [data.packages[x]];
                      systemIdTmp.push(data.packages[x].systemId);
                    }
                  } else
                  {
                    var addKitTmp=true;
                    if(data.packages[x].productCode)
                      for (var h = 0; h < kits[data.packages[x].systemId].length; h++) {
                        if(kits[data.packages[x].systemId][h].productCode==data.packages[x].productCode)
                          addKitTmp=false;
                      }
                    else
                      addKitTmp=false;
                    if(addKitTmp){
                      kits[data.packages[x].systemId].push(data.packages[x]);
                      systemIdTmp.push(data.packages[x].systemId);
                    }
                      
                  }
                }
                self.set('kits', kits);
                for (var z = 0; z < systemIdTmp.length; z++) {
                  self.trigger('kit:retrieved', [kits[systemIdTmp[z]], systemIdTmp[z]]);
                }
              };

              //Retrieving articles
              for (i = 0; i < data.packages.length; i++)
              {
                window.BticinoS4B.Instances.Models.ApplicationModel.getProducts(data.packages[i].packageClassId, valorizePackage);
              }
              $('.loaderKit').fadeOut('fast');
              data.packages=null;
            };

          if (currentSystem.specialData && currentSystem.specialData.kitWizardChoice)
          {
            window.BticinoS4B.Instances.Services.wizardServices.getPackagesByIdWizardChoiceRegardlessAccessoryLine(currentSystem.specialData.kitWizardChoice, successCallback, [currentSystem.id], this);
          }
          else
          {
            triggerEmpty(currentSystem.id);
          }
      },
      /*
      accessoryLineChosenEventHandler : function() {
        this.retrieveKitsForTheCurrentSystems();
      },
      */
      retrieveCategorySystem: function() {
        var self = this,
          successCallback = function(data) {
            var tmpHashName = '';
            retrievedCategorySystems = [];

            for (var i = 0; i < data.CategorySystems.length; i++) {
              tmpHashName = '';

              if (data.CategorySystems[i].specialData) {
                data.CategorySystems[i].specialData = JSON.parse(data.CategorySystems[i].specialData);
              } else {
                data.CategorySystems[i].specialData = {};
              }

              if (data.CategorySystems[i].code == '#2') {
                tmpHashName = 'termoregolazione';
              } else if (data.CategorySystems[i].code == '#4') {
                tmpHashName = 'antintrusione';
              } else if (data.CategorySystems[i].code == '#5+6') {
                tmpHashName = 'audiovideo';
              } else if (data.CategorySystems[i].code == '#13+20') {
                tmpHashName = 'automazione';
              } else if (data.CategorySystems[i].code == '#13') {
                tmpHashName = 'automazioneSemplice';
              } else if (data.CategorySystems[i].code == '#21') {
                tmpHashName = 'gestioneEnergia';
              }

              wizardChoiceId = data.CategorySystems[i].specialData;

              retrievedCategorySystems[i] = {
                id:          data.CategorySystems[i].code,
                name:        data.CategorySystems[i].caption,
                hashName:    tmpHashName,
                appName:     tmpHashName,
                idbus:       data.CategorySystems[i].idbus,
                busposition: data.CategorySystems[i].busposition,
                description: data.CategorySystems[i].description,
                specialData: data.CategorySystems[i].specialData
              };
              self.set('kits',[]);
              self.retrieveKitsForTheCurrentSystems(retrievedCategorySystems[i]);
            }
            window.BticinoS4B.Instances.Models.ApplicationModel.set("systems", retrievedCategorySystems);
            return retrievedCategorySystems;
          };

        window.BticinoS4B.Instances.Services.wizardServices.getEnabledCategorySystemListByLocalization('ITA', successCallback, [], self);
      }
    });

    SystemSelectionSingle.View = Backbone.View.extend({
      id: "system-selection-single",
      tagName: "section",
      template: "application/system-selection-single",
      events: {
        // "click a": "openSystemWindow",
        'click .addSystem-button': 'addSystemEventHandler',
        'click .importSystem-button': 'importSystemEventHandler',
        'click .deleteSystem-button': 'requestDeleteSystem',
        'click .buttonContainer a' : 'checkToken',
        'click .referencesKit': 'controlSelectedInput'
      },

      serialize: function() {
        return {
          app: app,
          buses: app.buses,
          systems: window.BticinoS4B.Instances.Models.ApplicationModel.get('systems')
        };
      },

      initialize: function() {
        this.model = new SystemSelectionSingle.Model();
        // BticinoS4B.Instances.Models.ApplicationModel.systemSelectionModel = new SystemSelection.Model();
        //var systems = this.model.retrieveCategorySystem();
        // window.BticinoS4B.eventAggregator.unbind("language:changed", null, this);
        //window.BticinoS4B.Instances.Models.systemSelectionSingleModel=this.model;
        window.BticinoS4B.Instances.Views.systemSelectionSingle = this;
        window.BticinoS4B.eventAggregator.bind("language:changed", this.render, this);
        window.BticinoS4B.eventAggregator.bind("language:changed", window.BticinoS4B.Instances.Views.systemSelectionSingle.model.retrieveCategorySystem, window.BticinoS4B.Instances.Views.systemSelectionSingle.model);
        this.model.bind('kit:retrieved',             this.kitRetrievedEventHandler, this);
        BticinoS4B.Instances.Models.ApplicationModel.set("kitCode",null);
        // $.cookie('solution', JSON.stringify(window.BticinoS4B.solution));
      },

      kitRetrievedEventHandler : function(addedKits) {
        var kitSection;
        var currentKit;
        var fetchedKits=[];
        var x,y;

        kitSection = this.$el.find('#system-'+addedKits[1].replace('#', '').replace('+','-')).find('.kitsContainer');

        // if(addedKits.length>0)
        for (var i =0; i<addedKits[0].length; i++) {
          currentKit = addedKits[0][i];
          if(currentKit.specialVars.referenceAccessoryLines){
            fetchedKits.push(currentKit);
          }else{
            /* if kit has no accessory line; use all accessor line able in the current location */
            if(addedKits[1]==currentKit.systemId){
              var accessoryLines = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines");
              currentKit.specialVars.referenceAccessoryLines = [];
              for (x = 0; x < accessoryLines.length; x++) {
                for(y = 0; y < accessoryLines[x].colors.length; y++)
                  {
                    if (accessoryLines[x].name != 'ND') { currentKit.specialVars.referenceAccessoryLines.push(accessoryLines[x].colors[y].accessoryLineId); }
                  }
                }
                fetchedKits.push(currentKit);
            }

          }
        }

        kitSection.find('.loaderKit').fadeOut('fast', function(){
          var toInsert;
          // kitSection.hide();
          $(this).css('display','block');
          // kitSection.fadeIn('fast');
          kitSection.find('.kitDetail').remove();
          for (var i = 0, length = fetchedKits.length; i < length; i++)
          {
            toInsert = new Kit.View({model : new Kit.Model(fetchedKits[i]), template : 'application/kitMultiAccessoryLine'});
            toInsert.render();
            kitSection.append(toInsert.$el.html());
            if(i===0 && kitSection.find('.insertKitLabel').length===0){
              kitSection.prepend('<p class="insertKitLabel">'+$.i18n._("IDS_W1_9157")+'</p>');
            }
          }
          window.customizeFormElements.call();
          $(this).css('display','none');
          
          
        });
      },

      controlSelectedInput: function(el){
        var systemName,accessorylineidSelected, onClickUrl;
        var idKit=el.currentTarget.attributes.kitid.nodeValue;
        
        var attr=$(el.target).parent().find('input').attr("checked");
        if(attr){
          $(".referencesKit[kitId="+idKit+"]").find("input").each(function(){
            $(this).removeAttr("checked");
            $(this).parent().find('.checkbox').css('background-position','0px 0px');
          });
          $(el.target).parent().find('input').attr("checked","checked");
          $(el.target).parent().find('.checkbox').css('background-position','0px -50px');
          systemName=$(el.target).parent().parent().parent().attr("systemName");
          accessorylineidSelected=el.currentTarget.attributes.accessorylineid.nodeValue;
          onClickUrl="window.open('"+BticinoS4B.baseUrl+"#system-selection-single/"+systemName+"?kit="+idKit+"&accessoryLineId="+accessorylineidSelected+"');return false;";
          $(el.target).parent().parent().parent().parent().find('.buttonContainer').find('a').attr('onClick',onClickUrl);
        }
        else
        {
          systemName = $(el.target).parent().parent().parent().attr("systemName");
          onClickUrl = "window.open('"+BticinoS4B.baseUrl+"#system-selection-single/"+systemName+"');return false;";
          $(el.target).parent().parent().parent().parent().find('.buttonContainer').find('a').attr('onClick',onClickUrl);
        }
          // el.currentTarget.childNodes[2].attributes={"checked":"checked"};
      },
            
      /*
      controlSelectedInput: function(el){

        var idKit=el.currentTarget.attributes.kitid.nodeValue,
            accessorylineidSelected=$(el.target).val(),
            systemName=$(el.target).parent().parent().parent().parent().attr("systemName"),
            onClickUrl="";
        
        if(accessorylineidSelected!="-1"){
          //change url onClick
          onClickUrl="window.open('"+BticinoS4B.baseUrl+"#system-selection-single/"+systemName+"?kit="+idKit+"&accessoryLineId="+accessorylineidSelected+"');return false;";
          $(el.target).parent().parent().parent().parent().parent().find('.buttonContainer').find('a').attr('onClick',onClickUrl);
        }else{
          //change url onClick
          onClickUrl="window.open('"+BticinoS4B.baseUrl+"#system-selection-single/"+systemName+"');return false;";
          $(el.target).parent().parent().parent().parent().parent().find('.buttonContainer').find('a').attr('onClick',onClickUrl);
        }
      },
      */
      addSystemEventHandler: function(e) {
        var idContainer = e.currentTarget.parentElement.parentElement.parentElement.id;
        if(idContainer){
          $("#"+idContainer).find('input:checked').each(function(){
            console.log($(this).attr("packageid"));
            BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine",retrievedAccessoryLines[1]);
            BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor",retrievedAccessoryLines[1].colors[0]);
            BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId",retrievedAccessoryLines[1].colors[0].accessoryLineId);
            BticinoS4B.Instances.Models.ApplicationModel.set("kitCode",$(this).attr("packageid"));
          });
        }
        
      },

      requestDeleteSystem: function(e) {
        if (confirm('Desideri eliminare il sistema inserito?')){
          var systemCode = e.currentTarget.attributes.idsystem.value;
          this.deleteSystemEventHandler(systemCode);
        }
        else
        {
          console.log('requestDeleteSystem: false');
        }
      },

      deleteSystemEventHandler: function(systemCode) {

        switch (systemCode)
          {
          case "#2":
            BticinoS4B.solution.thermoregulation            = {};
            BticinoS4B.solution.thermoregulation.inserted   = false;
            //alert('DELETE BticinoS4B.solution.thermoregulation');
            break;
          case "#4":
            BticinoS4B.solution.intrusionDetection          = {};
            BticinoS4B.solution.intrusionDetection.inserted = false;
            //alert('DELETE BticinoS4B.solution.intrusionDetection');
            break;
          case "#5+6":
            BticinoS4B.solution.audioVideo                  = {};
            BticinoS4B.solution.audioVideo.inserted         = false;
            //alert('DELETE BticinoS4B.solution.audioVideo');
            break;
          case "#13+20":
            BticinoS4B.solution.automation                  = {};
            BticinoS4B.solution.automation.inserted         = false;
            //alert('DELETE BticinoS4B.solution.automation');
            break;
          case "#13":
            BticinoS4B.solution.automationSimple            = {};
            BticinoS4B.solution.automationSimple.inserted   = false;
            //alert('DELETE BticinoS4B.solution.automationSimple');
            break;
          case "#21":
            BticinoS4B.solution.energyManagement            = {};
            BticinoS4B.solution.energyManagement.inserted   = false;
            //alert('DELETE BticinoS4B.solution.energyManagement');
            break;
          }
        //trick to refresh view
        window.BticinoS4B.eventAggregator.trigger("language:changed");
      },

      importSystemEventHandler: function(e) {
        var systemCode = e.currentTarget.attributes.idsystem.value;
        var accessoryLine = window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
        window.BticinoS4B.vars.systemToImport = systemCode;
        window.BticinoS4B.Instances.Views.headerView.importPopup.setSystem(systemCode);
        window.BticinoS4B.Instances.Views.headerView.importPopup.show();
        //alert('importSystemEventHandler');
      },

      selectColorLine: function(e) {
        var self = this;
        // this.$el.find('.kitDetail').fadeOut('fast', function(){
        //   self.$el.find('.loaderKit').fadeIn('fast');
        // });
        if(!self.isInsertedSystem()){
          var idColors        = e.currentTarget.attributes.nameColors.value,
              idAccessoryLine = e.currentTarget.attributes.nameAccessoryLine.value;
          this.model.accessoryLineChosen(idColors, idAccessoryLine);

          $('.colorSlides button.selected').removeClass('selected');
          e.currentTarget.className = 'selected';
        }else{
          alert(""+$.i18n._("IDS_W1_9147")+"");
        }

      },

      openSystemWindow: function(e) {
        e.preventDefault();
        window.open(e.currentTarget.href,'_blank');
        return false;
      },

      afterRender: function() {
        this.sliderSystem();
        this.displayDescription();
        $('#system-selection-single').css('min-height',$(window).height()-$('header').height()-1);
        $('#container-single').css('min-height',$('#system-selection-single').height()-21);
      },

      beforeRender: function() {
        if($('#serieProgettoLabel').html()=='nessuna')
        {
          $('#serieProgettoLabel').html(window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine").name);
        }
          // $('#serieProgettoLabel').html(line.name);
        if($('#coloreLabel').html()=='nessuno'){
          idColors=window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor").name;
          if (idColors)
          {
            $('#coloreLabel').html(idColors);
          }
          else
          {
            $('#coloreLabel').html('-');
          }
        }

      },

      sliderSystem: function() {
        var that=this;
        if ($('.flexslider').length > 0){
          //se c'è almeno un inserito non selezionare slider!!!
          // if(BticinoS4B.solution.audioVideo.inserted)
          var start=0;
          var lineSelected=0;
          if(window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenLine.id)
            lineSelected=window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenLine.id;
          if(lineSelected)
            start=$("li#"+lineSelected,".flexslider").attr("positionId");
          $('.flexslider').flexslider({
            animation: 'slide',
            prevText: '', //String: Set the text for the "previous" directionNav item
            nextText: '',
            slideshow: false,
            startAt: start
          });
          that.selectedColorImportSystem(lineSelected);
          // $('.flexslider a').attr('href','javascript:void(0);');
        }
      },

      selectedColorImportSystem: function(lineSelected){
        var colorId=0;
        var lineId=lineSelected;
        if(window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenColor){
          colorId=window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenColor.id;
        }
        this.model.accessoryLineChosen(colorId, lineId);
        $('.colorSlides button.selected').removeClass('selected');
        $('.colorSlides button[nameaccessoryline='+lineId+']').each(function(){
          if(colorId){
            if($(this).attr('namecolors')==colorId)
              $(this).addClass('selected');
          }else
            $(this).addClass('selected');
        });
      },

      isInsertedSystem:function(){
        if(window.BticinoS4B.solution.thermoregulation.inserted || window.BticinoS4B.solution.audioVideo.inserted || window.BticinoS4B.solution.automation.inserted || window.BticinoS4B.solution.intrusionDetection.inserted)
          return true;
        else
          return false;
      },

      displayDescription: function() {
        var parentDescription;
        var defaultHeight = 50;
        var height = 0;
        $(".descriptionContinue").toggle(function() {
          parentDescription = $(this).parent().find('.descriptionBus');
          var curHeight = parentDescription.height();
          if (curHeight == defaultHeight) {
            height = parentDescription.css('height', 'auto').height();
            parentDescription.css('height', curHeight);
          } else
            height = curHeight;
          parentDescription.animate({
            height: height
          }, 200);
        }, function() {
          parentDescription = $(this).parent().find('.descriptionBus');
          parentDescription.animate({
            height: defaultHeight
          }, 200);
        });
      }
    });

    return SystemSelectionSingle;

  });